module.exports = __webpack_public_path__ + "static/media/feed-like.441c5edb.svg";